import { statusLabel, statusTone, apptStatusTone } from "../lib/format";

export function ClientStatusBadge({ status }) {
  return (
    <span
      data-testid={`client-status-${status}`}
      className={`inline-flex items-center rounded-full px-3 py-0.5 text-[11px] font-medium tracking-wide border ${statusTone(status)}`}
    >
      {statusLabel(status)}
    </span>
  );
}

export function AppointmentStatusBadge({ status }) {
  return (
    <span
      className={`inline-flex items-center rounded-full px-3 py-0.5 text-[11px] font-medium tracking-wide ${apptStatusTone(status)}`}
    >
      {status.charAt(0).toUpperCase() + status.slice(1)}
    </span>
  );
}
